export const FORM_SECTIONS = {
  CLIENT_DETAILS: 'A',
  INCOME: 'B',
  DEDUCTIONS: 'C',
  TAX_OFFSETS: 'D',
  SPOUSE_INFO: 'E'
};

export const SECTION_TITLES = {
  [FORM_SECTIONS.CLIENT_DETAILS]: 'Client Details',
  [FORM_SECTIONS.INCOME]: 'Income',
  [FORM_SECTIONS.DEDUCTIONS]: 'Deductions',
  [FORM_SECTIONS.TAX_OFFSETS]: 'Tax Offsets & Health',
  [FORM_SECTIONS.SPOUSE_INFO]: 'Spouse Information'
};

export const INCOME_TYPES = {
  SALARY_WAGES: 'Salary or Wages',
  ALLOWANCES_TIPS: 'Allowances, Tips, Directors Fees, Earnings',
  EMPLOYER_LUMP_SUM: 'Employer Lump Sum Payments',
  EMPLOYMENT_TERMINATION: 'Employment Termination Payments',
  AUST_GOVT_ALLOWANCES: 'Australian Govt Allowances & Payments',
  AUST_GOVT_PENSIONS: 'Aust Gov Pensions and Allowances',
  AUST_ANNUITIES_SUPER: 'Aust Annuities & Super Income Streams',
  AUST_SUPER_LUMP_SUM: 'Australian Super Lump Sum Payments',
  ATTRIBUTED_PERSONAL_SERVICES: 'Attributed Personal Services Income',
  INTEREST: 'Interest Received',
  DIVIDENDS: 'Dividends',
  EMPLOYEE_SHARE_SCHEME: 'Employee Share Scheme (ESS)',
  PARTNERSHIPS_TRUSTS: 'Partnerships/Trusts (Managed Investment Funds)',
  CAPITAL_GAINS: 'Sale of Assets (Capital Gains Tax)',
  FOREIGN_INCOME: 'Foreign Income and/or Foreign Tax Credits',
  RENTAL: 'Rental Income and Expenses',
  OTHER: 'Any Other Income'
};

export const DEDUCTION_TYPES = {
  VEHICLE: 'Work Related Motor Vehicle Expenses',
  TRAVEL: 'Work Related Travel Expenses',
  UNIFORMS: 'Work Related Uniforms and Protective Clothing',
  EDUCATION: 'Self Education Expenses',
  OTHER_WORK: 'Other Work Related Expenses',
  INTEREST: 'Interest Deductions',
  DIVIDEND: 'Dividend Deductions',
  GIFTS: 'Gifts to Charities, Approved Building Funds, Political Party',
  TAX_FEES: 'Tax Fees for Tax Return Preparation',
  SUPER_CONTRIBUTIONS: 'Superannuation Contributions (Self-employed)',
  INSURANCE: 'Insurance – Loss of Income / Income Protection',
  HOME_OFFICE: 'Working From Home (WFH)'
};

export const TAX_OFFSETS = {
  SPOUSE: 'T1 - Spouse (born before 1 July 1952, income < $10,166)',
  SENIOR: 'T2 - Senior Australians (pension age 65 or older)',
  PENSIONER: 'T3 - Pensioner offset',
  SUPER_INCOME_STREAM: 'T4 - Australian Superannuation income stream tax offset',
  ZONE: 'T5 - Zone / remote area and overseas forces offsets',
  MEDICAL: 'T6 - Net medical expenses over threshold',
  INVALID_CARER: 'T7 - Invalid and Carer (spouse, child, parent, brother or sister 16yrs+)',
  MATURE_AGE: 'T9 - Mature age worker (born before 1 July 1957, net income < $63,000)',
  NONE: 'None'
};

export const HEALTH_COVER_CODES = [
  { value: 'A', label: 'A - Single' },
  { value: 'B', label: 'B - Single Parent' },
  { value: 'C', label: 'C - Couple' },
  { value: 'D', label: 'D - Family' },
  { value: 'E', label: 'E - Family with Children' }
];

export const VEHICLE_METHODS = {
  CENTS_PER_KM: 'Cents per Kilometre Method (85 cents per KM from 1 July 2024)',
  LOGBOOK: 'Logbook Method (must be completed every 5 years)',
  HIRE_PURCHASE: 'Car Hire Purchase / Chattel Mortgage'
};

export const WFH_RATES = {
  '67c': '67 cents per hour (simplified method) - Cannot claim internet, energy, phone, stationery separately',
  '52c': '52 cents per hour (actual cost method) - Can claim additional running expenses'
};

export const FILE_TYPES = {
  PDF: 'application/pdf',
  IMAGE: 'image/*',
  ALL: '*/*'
};

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL: 'Please enter a valid email address',
  PHONE: 'Please enter a valid phone number',
  BSB: 'BSB must be 6 digits',
  ACCOUNT_NUMBER: 'Account number must be between 4-9 digits',
  PERCENTAGE: 'Percentage must be between 0-100',
  POSITIVE_NUMBER: 'Must be a positive number'
}; 